// @ts-nocheck

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as AuthenticatedNoAccessImport } from './routes/_authenticated/no-access'
import { Route as AuthSsoImport } from './routes/_auth/sso'
import { Route as AuthResetPasswordImport } from './routes/_auth/reset-password'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordImport } from './routes/_auth/forgot-password'
import { Route as AuthenticatedWorkspacesIndexImport } from './routes/_authenticated/workspaces/index'
import { Route as AuthenticatedPortfoliosIndexImport } from './routes/_authenticated/portfolios/index'
import { Route as AuthenticatedOrganizationsIndexImport } from './routes/_authenticated/organizations/index'
import { Route as AuthSsoIndexImport } from './routes/_auth/sso.index'
import { Route as AuthenticatedWWorkspaceSlugImport } from './routes/_authenticated/w/$workspaceSlug'
import { Route as AuthenticatedReportsOpportunityImport } from './routes/_authenticated/reports.opportunity'
import { Route as AuthenticatedOrganizationsOrganizationIdImport } from './routes/_authenticated/organizations/$organizationId'
import { Route as AuthSsoErrorImport } from './routes/_auth/sso.error'
import { Route as AuthSsoCallbackImport } from './routes/_auth/sso.callback'
import { Route as AuthSsoOrgSlugImport } from './routes/_auth/sso.$orgSlug'
import { Route as AuthenticatedWWorkspaceSlugIndexImport } from './routes/_authenticated/w/$workspaceSlug/index'
import { Route as AuthenticatedWWorkspaceSlugOrgUserManagementImport } from './routes/_authenticated/w/$workspaceSlug/org-user-management'
import { Route as AuthenticatedReportsOpportunityProductsImport } from './routes/_authenticated/reports.opportunity_.products'
import { Route as AuthenticatedReportsOpportunityBrandIdImport } from './routes/_authenticated/reports.opportunity_.$brandId'
import { Route as AuthenticatedPortfoliosPortfolioIdWorkspacesImport } from './routes/_authenticated/portfolios/$portfolioId/workspaces'
import { Route as AuthenticatedWWorkspaceSlugOrganizationsIndexImport } from './routes/_authenticated/w/$workspaceSlug/organizations/index'
import { Route as AuthenticatedWWorkspaceSlugLibraryIndexImport } from './routes/_authenticated/w/$workspaceSlug/library/index'
import { Route as AuthenticatedWWorkspaceSlugExploreIndexImport } from './routes/_authenticated/w/$workspaceSlug/explore/index'
import { Route as AuthenticatedWWorkspaceSlugSettingsTagsImport } from './routes/_authenticated/w/$workspaceSlug/settings.tags'
import { Route as AuthenticatedWWorkspaceSlugSettingsIntegrationsImport } from './routes/_authenticated/w/$workspaceSlug/settings.integrations'
import { Route as AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdImport } from './routes/_authenticated/w/$workspaceSlug/organizations/$organizationId'
import { Route as AuthenticatedWWorkspaceSlugExploreCategoryL1Import } from './routes/_authenticated/w/$workspaceSlug/explore/$categoryL1'
import { Route as AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcImport } from './routes/_authenticated/w/$workspaceSlug/settings.integrations.avc'
import { Route as AuthenticatedWWorkspaceSlugLibraryProductsPdpIdImport } from './routes/_authenticated/w/$workspaceSlug/library/products.$pdpId'
import { Route as AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdImport } from './routes/_authenticated/w/$workspaceSlug/library/collections.$collectionId'
import { Route as AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdImport } from './routes/_authenticated/w/$workspaceSlug/library/benchmarks.$benchmarkId'
import { Route as AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdImport } from './routes/_authenticated/w/$workspaceSlug/library/assets.$assetId'
import { Route as AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Import } from './routes/_authenticated/w/$workspaceSlug/explore/$categoryL1_.$categoryL4'
import { Route as AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsImport } from './routes/_authenticated/w/$workspaceSlug/library/collections.$collectionId_.trends'
import { Route as AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareImport } from './routes/_authenticated/w/$workspaceSlug/library/collections.$collectionId_.compare'
import { Route as AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationImport } from './routes/_authenticated/w/$workspaceSlug/explore/$categoryL1_.$categoryL4_.$classification'

// Create/Update Routes

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedNoAccessRoute = AuthenticatedNoAccessImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthSsoRoute = AuthSsoImport.update({
  id: '/_auth/sso',
  path: '/sso',
  getParentRoute: () => rootRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/_auth/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/_auth/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  id: '/_auth/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedWorkspacesIndexRoute =
  AuthenticatedWorkspacesIndexImport.update({
    id: '/workspaces/',
    path: '/workspaces/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPortfoliosIndexRoute =
  AuthenticatedPortfoliosIndexImport.update({
    id: '/portfolios/',
    path: '/portfolios/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthSsoIndexRoute = AuthSsoIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthenticatedWWorkspaceSlugRoute =
  AuthenticatedWWorkspaceSlugImport.update({
    id: '/w/$workspaceSlug',
    path: '/w/$workspaceSlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedReportsOpportunityRoute =
  AuthenticatedReportsOpportunityImport.update({
    id: '/reports/opportunity',
    path: '/reports/opportunity',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedOrganizationsOrganizationIdRoute =
  AuthenticatedOrganizationsOrganizationIdImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthSsoErrorRoute = AuthSsoErrorImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthSsoCallbackRoute = AuthSsoCallbackImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthSsoOrgSlugRoute = AuthSsoOrgSlugImport.update({
  id: '/$orgSlug',
  path: '/$orgSlug',
  getParentRoute: () => AuthSsoRoute,
} as any)

const AuthenticatedWWorkspaceSlugIndexRoute =
  AuthenticatedWWorkspaceSlugIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugOrgUserManagementRoute =
  AuthenticatedWWorkspaceSlugOrgUserManagementImport.update({
    id: '/org-user-management',
    path: '/org-user-management',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedReportsOpportunityProductsRoute =
  AuthenticatedReportsOpportunityProductsImport.update({
    id: '/reports/opportunity_/products',
    path: '/reports/opportunity/products',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedReportsOpportunityBrandIdRoute =
  AuthenticatedReportsOpportunityBrandIdImport.update({
    id: '/reports/opportunity_/$brandId',
    path: '/reports/opportunity/$brandId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPortfoliosPortfolioIdWorkspacesRoute =
  AuthenticatedPortfoliosPortfolioIdWorkspacesImport.update({
    id: '/portfolios/$portfolioId/workspaces',
    path: '/portfolios/$portfolioId/workspaces',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedWWorkspaceSlugOrganizationsIndexRoute =
  AuthenticatedWWorkspaceSlugOrganizationsIndexImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugLibraryIndexRoute =
  AuthenticatedWWorkspaceSlugLibraryIndexImport.update({
    id: '/library/',
    path: '/library/',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugExploreIndexRoute =
  AuthenticatedWWorkspaceSlugExploreIndexImport.update({
    id: '/explore/',
    path: '/explore/',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugSettingsTagsRoute =
  AuthenticatedWWorkspaceSlugSettingsTagsImport.update({
    id: '/settings/tags',
    path: '/settings/tags',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugSettingsIntegrationsRoute =
  AuthenticatedWWorkspaceSlugSettingsIntegrationsImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute =
  AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugExploreCategoryL1Route =
  AuthenticatedWWorkspaceSlugExploreCategoryL1Import.update({
    id: '/explore/$categoryL1',
    path: '/explore/$categoryL1',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute =
  AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcImport.update({
    id: '/avc',
    path: '/avc',
    getParentRoute: () => AuthenticatedWWorkspaceSlugSettingsIntegrationsRoute,
  } as any)

const AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute =
  AuthenticatedWWorkspaceSlugLibraryProductsPdpIdImport.update({
    id: '/library/products/$pdpId',
    path: '/library/products/$pdpId',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute =
  AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdImport.update({
    id: '/library/collections/$collectionId',
    path: '/library/collections/$collectionId',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute =
  AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdImport.update({
    id: '/library/benchmarks/$benchmarkId',
    path: '/library/benchmarks/$benchmarkId',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute =
  AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdImport.update({
    id: '/library/assets/$assetId',
    path: '/library/assets/$assetId',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route =
  AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Import.update({
    id: '/explore/$categoryL1_/$categoryL4',
    path: '/explore/$categoryL1/$categoryL4',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute =
  AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsImport.update({
    id: '/library/collections/$collectionId_/trends',
    path: '/library/collections/$collectionId/trends',
    getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
  } as any)

const AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute =
  AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareImport.update(
    {
      id: '/library/collections/$collectionId_/compare',
      path: '/library/collections/$collectionId/compare',
      getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
    } as any,
  )

const AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute =
  AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationImport.update(
    {
      id: '/explore/$categoryL1_/$categoryL4_/$classification',
      path: '/explore/$categoryL1/$categoryL4/$classification',
      getParentRoute: () => AuthenticatedWWorkspaceSlugRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_auth/sso': {
      id: '/_auth/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof AuthSsoImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/no-access': {
      id: '/_authenticated/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof AuthenticatedNoAccessImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_auth/sso/$orgSlug': {
      id: '/_auth/sso/$orgSlug'
      path: '/$orgSlug'
      fullPath: '/sso/$orgSlug'
      preLoaderRoute: typeof AuthSsoOrgSlugImport
      parentRoute: typeof AuthSsoImport
    }
    '/_auth/sso/callback': {
      id: '/_auth/sso/callback'
      path: '/callback'
      fullPath: '/sso/callback'
      preLoaderRoute: typeof AuthSsoCallbackImport
      parentRoute: typeof AuthSsoImport
    }
    '/_auth/sso/error': {
      id: '/_auth/sso/error'
      path: '/error'
      fullPath: '/sso/error'
      preLoaderRoute: typeof AuthSsoErrorImport
      parentRoute: typeof AuthSsoImport
    }
    '/_authenticated/organizations/$organizationId': {
      id: '/_authenticated/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedOrganizationsOrganizationIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/reports/opportunity': {
      id: '/_authenticated/reports/opportunity'
      path: '/reports/opportunity'
      fullPath: '/reports/opportunity'
      preLoaderRoute: typeof AuthenticatedReportsOpportunityImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/w/$workspaceSlug': {
      id: '/_authenticated/w/$workspaceSlug'
      path: '/w/$workspaceSlug'
      fullPath: '/w/$workspaceSlug'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_auth/sso/': {
      id: '/_auth/sso/'
      path: '/'
      fullPath: '/sso/'
      preLoaderRoute: typeof AuthSsoIndexImport
      parentRoute: typeof AuthSsoImport
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/portfolios/': {
      id: '/_authenticated/portfolios/'
      path: '/portfolios'
      fullPath: '/portfolios'
      preLoaderRoute: typeof AuthenticatedPortfoliosIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/workspaces/': {
      id: '/_authenticated/workspaces/'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof AuthenticatedWorkspacesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/portfolios/$portfolioId/workspaces': {
      id: '/_authenticated/portfolios/$portfolioId/workspaces'
      path: '/portfolios/$portfolioId/workspaces'
      fullPath: '/portfolios/$portfolioId/workspaces'
      preLoaderRoute: typeof AuthenticatedPortfoliosPortfolioIdWorkspacesImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/reports/opportunity_/$brandId': {
      id: '/_authenticated/reports/opportunity_/$brandId'
      path: '/reports/opportunity/$brandId'
      fullPath: '/reports/opportunity/$brandId'
      preLoaderRoute: typeof AuthenticatedReportsOpportunityBrandIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/reports/opportunity_/products': {
      id: '/_authenticated/reports/opportunity_/products'
      path: '/reports/opportunity/products'
      fullPath: '/reports/opportunity/products'
      preLoaderRoute: typeof AuthenticatedReportsOpportunityProductsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/w/$workspaceSlug/org-user-management': {
      id: '/_authenticated/w/$workspaceSlug/org-user-management'
      path: '/org-user-management'
      fullPath: '/w/$workspaceSlug/org-user-management'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugOrgUserManagementImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/': {
      id: '/_authenticated/w/$workspaceSlug/'
      path: '/'
      fullPath: '/w/$workspaceSlug/'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugIndexImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/explore/$categoryL1': {
      id: '/_authenticated/w/$workspaceSlug/explore/$categoryL1'
      path: '/explore/$categoryL1'
      fullPath: '/w/$workspaceSlug/explore/$categoryL1'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugExploreCategoryL1Import
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/organizations/$organizationId': {
      id: '/_authenticated/w/$workspaceSlug/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/w/$workspaceSlug/organizations/$organizationId'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/settings/integrations': {
      id: '/_authenticated/w/$workspaceSlug/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/w/$workspaceSlug/settings/integrations'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/settings/tags': {
      id: '/_authenticated/w/$workspaceSlug/settings/tags'
      path: '/settings/tags'
      fullPath: '/w/$workspaceSlug/settings/tags'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugSettingsTagsImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/explore/': {
      id: '/_authenticated/w/$workspaceSlug/explore/'
      path: '/explore'
      fullPath: '/w/$workspaceSlug/explore'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugExploreIndexImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/library/': {
      id: '/_authenticated/w/$workspaceSlug/library/'
      path: '/library'
      fullPath: '/w/$workspaceSlug/library'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugLibraryIndexImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/organizations/': {
      id: '/_authenticated/w/$workspaceSlug/organizations/'
      path: '/organizations'
      fullPath: '/w/$workspaceSlug/organizations'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugOrganizationsIndexImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4': {
      id: '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4'
      path: '/explore/$categoryL1/$categoryL4'
      fullPath: '/w/$workspaceSlug/explore/$categoryL1/$categoryL4'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Import
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/library/assets/$assetId': {
      id: '/_authenticated/w/$workspaceSlug/library/assets/$assetId'
      path: '/library/assets/$assetId'
      fullPath: '/w/$workspaceSlug/library/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/library/benchmarks/$benchmarkId': {
      id: '/_authenticated/w/$workspaceSlug/library/benchmarks/$benchmarkId'
      path: '/library/benchmarks/$benchmarkId'
      fullPath: '/w/$workspaceSlug/library/benchmarks/$benchmarkId'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/library/collections/$collectionId': {
      id: '/_authenticated/w/$workspaceSlug/library/collections/$collectionId'
      path: '/library/collections/$collectionId'
      fullPath: '/w/$workspaceSlug/library/collections/$collectionId'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/library/products/$pdpId': {
      id: '/_authenticated/w/$workspaceSlug/library/products/$pdpId'
      path: '/library/products/$pdpId'
      fullPath: '/w/$workspaceSlug/library/products/$pdpId'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugLibraryProductsPdpIdImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/settings/integrations/avc': {
      id: '/_authenticated/w/$workspaceSlug/settings/integrations/avc'
      path: '/avc'
      fullPath: '/w/$workspaceSlug/settings/integrations/avc'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsImport
    }
    '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4_/$classification': {
      id: '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4_/$classification'
      path: '/explore/$categoryL1/$categoryL4/$classification'
      fullPath: '/w/$workspaceSlug/explore/$categoryL1/$categoryL4/$classification'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/compare': {
      id: '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/compare'
      path: '/library/collections/$collectionId/compare'
      fullPath: '/w/$workspaceSlug/library/collections/$collectionId/compare'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
    '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/trends': {
      id: '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/trends'
      path: '/library/collections/$collectionId/trends'
      fullPath: '/w/$workspaceSlug/library/collections/$collectionId/trends'
      preLoaderRoute: typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsImport
      parentRoute: typeof AuthenticatedWWorkspaceSlugImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteChildren {
  AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute: typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute
}

const AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteChildren: AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteChildren =
  {
    AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute:
      AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute,
  }

const AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteWithChildren =
  AuthenticatedWWorkspaceSlugSettingsIntegrationsRoute._addFileChildren(
    AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteChildren,
  )

interface AuthenticatedWWorkspaceSlugRouteChildren {
  AuthenticatedWWorkspaceSlugOrgUserManagementRoute: typeof AuthenticatedWWorkspaceSlugOrgUserManagementRoute
  AuthenticatedWWorkspaceSlugIndexRoute: typeof AuthenticatedWWorkspaceSlugIndexRoute
  AuthenticatedWWorkspaceSlugExploreCategoryL1Route: typeof AuthenticatedWWorkspaceSlugExploreCategoryL1Route
  AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute: typeof AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute
  AuthenticatedWWorkspaceSlugSettingsIntegrationsRoute: typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteWithChildren
  AuthenticatedWWorkspaceSlugSettingsTagsRoute: typeof AuthenticatedWWorkspaceSlugSettingsTagsRoute
  AuthenticatedWWorkspaceSlugExploreIndexRoute: typeof AuthenticatedWWorkspaceSlugExploreIndexRoute
  AuthenticatedWWorkspaceSlugLibraryIndexRoute: typeof AuthenticatedWWorkspaceSlugLibraryIndexRoute
  AuthenticatedWWorkspaceSlugOrganizationsIndexRoute: typeof AuthenticatedWWorkspaceSlugOrganizationsIndexRoute
  AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route: typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route
  AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute: typeof AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute
  AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute: typeof AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute
  AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute: typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute
  AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute: typeof AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute
  AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute: typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute
  AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute: typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute
  AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute: typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute
}

const AuthenticatedWWorkspaceSlugRouteChildren: AuthenticatedWWorkspaceSlugRouteChildren =
  {
    AuthenticatedWWorkspaceSlugOrgUserManagementRoute:
      AuthenticatedWWorkspaceSlugOrgUserManagementRoute,
    AuthenticatedWWorkspaceSlugIndexRoute:
      AuthenticatedWWorkspaceSlugIndexRoute,
    AuthenticatedWWorkspaceSlugExploreCategoryL1Route:
      AuthenticatedWWorkspaceSlugExploreCategoryL1Route,
    AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute:
      AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute,
    AuthenticatedWWorkspaceSlugSettingsIntegrationsRoute:
      AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteWithChildren,
    AuthenticatedWWorkspaceSlugSettingsTagsRoute:
      AuthenticatedWWorkspaceSlugSettingsTagsRoute,
    AuthenticatedWWorkspaceSlugExploreIndexRoute:
      AuthenticatedWWorkspaceSlugExploreIndexRoute,
    AuthenticatedWWorkspaceSlugLibraryIndexRoute:
      AuthenticatedWWorkspaceSlugLibraryIndexRoute,
    AuthenticatedWWorkspaceSlugOrganizationsIndexRoute:
      AuthenticatedWWorkspaceSlugOrganizationsIndexRoute,
    AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route:
      AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route,
    AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute:
      AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute,
    AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute:
      AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute,
    AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute:
      AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute,
    AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute:
      AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute,
    AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute:
      AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute,
    AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute:
      AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute,
    AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute:
      AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute,
  }

const AuthenticatedWWorkspaceSlugRouteWithChildren =
  AuthenticatedWWorkspaceSlugRoute._addFileChildren(
    AuthenticatedWWorkspaceSlugRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedNoAccessRoute: typeof AuthenticatedNoAccessRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOrganizationsOrganizationIdRoute: typeof AuthenticatedOrganizationsOrganizationIdRoute
  AuthenticatedReportsOpportunityRoute: typeof AuthenticatedReportsOpportunityRoute
  AuthenticatedWWorkspaceSlugRoute: typeof AuthenticatedWWorkspaceSlugRouteWithChildren
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedPortfoliosIndexRoute: typeof AuthenticatedPortfoliosIndexRoute
  AuthenticatedWorkspacesIndexRoute: typeof AuthenticatedWorkspacesIndexRoute
  AuthenticatedPortfoliosPortfolioIdWorkspacesRoute: typeof AuthenticatedPortfoliosPortfolioIdWorkspacesRoute
  AuthenticatedReportsOpportunityBrandIdRoute: typeof AuthenticatedReportsOpportunityBrandIdRoute
  AuthenticatedReportsOpportunityProductsRoute: typeof AuthenticatedReportsOpportunityProductsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedNoAccessRoute: AuthenticatedNoAccessRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOrganizationsOrganizationIdRoute:
    AuthenticatedOrganizationsOrganizationIdRoute,
  AuthenticatedReportsOpportunityRoute: AuthenticatedReportsOpportunityRoute,
  AuthenticatedWWorkspaceSlugRoute:
    AuthenticatedWWorkspaceSlugRouteWithChildren,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedPortfoliosIndexRoute: AuthenticatedPortfoliosIndexRoute,
  AuthenticatedWorkspacesIndexRoute: AuthenticatedWorkspacesIndexRoute,
  AuthenticatedPortfoliosPortfolioIdWorkspacesRoute:
    AuthenticatedPortfoliosPortfolioIdWorkspacesRoute,
  AuthenticatedReportsOpportunityBrandIdRoute:
    AuthenticatedReportsOpportunityBrandIdRoute,
  AuthenticatedReportsOpportunityProductsRoute:
    AuthenticatedReportsOpportunityProductsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuthSsoRouteChildren {
  AuthSsoOrgSlugRoute: typeof AuthSsoOrgSlugRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
  AuthSsoErrorRoute: typeof AuthSsoErrorRoute
  AuthSsoIndexRoute: typeof AuthSsoIndexRoute
}

const AuthSsoRouteChildren: AuthSsoRouteChildren = {
  AuthSsoOrgSlugRoute: AuthSsoOrgSlugRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  AuthSsoErrorRoute: AuthSsoErrorRoute,
  AuthSsoIndexRoute: AuthSsoIndexRoute,
}

const AuthSsoRouteWithChildren =
  AuthSsoRoute._addFileChildren(AuthSsoRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sso': typeof AuthSsoRouteWithChildren
  '/no-access': typeof AuthenticatedNoAccessRoute
  '/': typeof AuthenticatedIndexRoute
  '/sso/$orgSlug': typeof AuthSsoOrgSlugRoute
  '/sso/callback': typeof AuthSsoCallbackRoute
  '/sso/error': typeof AuthSsoErrorRoute
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/reports/opportunity': typeof AuthenticatedReportsOpportunityRoute
  '/w/$workspaceSlug': typeof AuthenticatedWWorkspaceSlugRouteWithChildren
  '/sso/': typeof AuthSsoIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/portfolios': typeof AuthenticatedPortfoliosIndexRoute
  '/workspaces': typeof AuthenticatedWorkspacesIndexRoute
  '/portfolios/$portfolioId/workspaces': typeof AuthenticatedPortfoliosPortfolioIdWorkspacesRoute
  '/reports/opportunity/$brandId': typeof AuthenticatedReportsOpportunityBrandIdRoute
  '/reports/opportunity/products': typeof AuthenticatedReportsOpportunityProductsRoute
  '/w/$workspaceSlug/org-user-management': typeof AuthenticatedWWorkspaceSlugOrgUserManagementRoute
  '/w/$workspaceSlug/': typeof AuthenticatedWWorkspaceSlugIndexRoute
  '/w/$workspaceSlug/explore/$categoryL1': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1Route
  '/w/$workspaceSlug/organizations/$organizationId': typeof AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute
  '/w/$workspaceSlug/settings/integrations': typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteWithChildren
  '/w/$workspaceSlug/settings/tags': typeof AuthenticatedWWorkspaceSlugSettingsTagsRoute
  '/w/$workspaceSlug/explore': typeof AuthenticatedWWorkspaceSlugExploreIndexRoute
  '/w/$workspaceSlug/library': typeof AuthenticatedWWorkspaceSlugLibraryIndexRoute
  '/w/$workspaceSlug/organizations': typeof AuthenticatedWWorkspaceSlugOrganizationsIndexRoute
  '/w/$workspaceSlug/explore/$categoryL1/$categoryL4': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route
  '/w/$workspaceSlug/library/assets/$assetId': typeof AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute
  '/w/$workspaceSlug/library/benchmarks/$benchmarkId': typeof AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute
  '/w/$workspaceSlug/library/collections/$collectionId': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute
  '/w/$workspaceSlug/library/products/$pdpId': typeof AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute
  '/w/$workspaceSlug/settings/integrations/avc': typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute
  '/w/$workspaceSlug/explore/$categoryL1/$categoryL4/$classification': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute
  '/w/$workspaceSlug/library/collections/$collectionId/compare': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute
  '/w/$workspaceSlug/library/collections/$collectionId/trends': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute
}

export interface FileRoutesByTo {
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/no-access': typeof AuthenticatedNoAccessRoute
  '/': typeof AuthenticatedIndexRoute
  '/sso/$orgSlug': typeof AuthSsoOrgSlugRoute
  '/sso/callback': typeof AuthSsoCallbackRoute
  '/sso/error': typeof AuthSsoErrorRoute
  '/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/reports/opportunity': typeof AuthenticatedReportsOpportunityRoute
  '/sso': typeof AuthSsoIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/portfolios': typeof AuthenticatedPortfoliosIndexRoute
  '/workspaces': typeof AuthenticatedWorkspacesIndexRoute
  '/portfolios/$portfolioId/workspaces': typeof AuthenticatedPortfoliosPortfolioIdWorkspacesRoute
  '/reports/opportunity/$brandId': typeof AuthenticatedReportsOpportunityBrandIdRoute
  '/reports/opportunity/products': typeof AuthenticatedReportsOpportunityProductsRoute
  '/w/$workspaceSlug/org-user-management': typeof AuthenticatedWWorkspaceSlugOrgUserManagementRoute
  '/w/$workspaceSlug': typeof AuthenticatedWWorkspaceSlugIndexRoute
  '/w/$workspaceSlug/explore/$categoryL1': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1Route
  '/w/$workspaceSlug/organizations/$organizationId': typeof AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute
  '/w/$workspaceSlug/settings/integrations': typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteWithChildren
  '/w/$workspaceSlug/settings/tags': typeof AuthenticatedWWorkspaceSlugSettingsTagsRoute
  '/w/$workspaceSlug/explore': typeof AuthenticatedWWorkspaceSlugExploreIndexRoute
  '/w/$workspaceSlug/library': typeof AuthenticatedWWorkspaceSlugLibraryIndexRoute
  '/w/$workspaceSlug/organizations': typeof AuthenticatedWWorkspaceSlugOrganizationsIndexRoute
  '/w/$workspaceSlug/explore/$categoryL1/$categoryL4': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route
  '/w/$workspaceSlug/library/assets/$assetId': typeof AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute
  '/w/$workspaceSlug/library/benchmarks/$benchmarkId': typeof AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute
  '/w/$workspaceSlug/library/collections/$collectionId': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute
  '/w/$workspaceSlug/library/products/$pdpId': typeof AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute
  '/w/$workspaceSlug/settings/integrations/avc': typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute
  '/w/$workspaceSlug/explore/$categoryL1/$categoryL4/$classification': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute
  '/w/$workspaceSlug/library/collections/$collectionId/compare': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute
  '/w/$workspaceSlug/library/collections/$collectionId/trends': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sso': typeof AuthSsoRouteWithChildren
  '/_authenticated/no-access': typeof AuthenticatedNoAccessRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_auth/sso/$orgSlug': typeof AuthSsoOrgSlugRoute
  '/_auth/sso/callback': typeof AuthSsoCallbackRoute
  '/_auth/sso/error': typeof AuthSsoErrorRoute
  '/_authenticated/organizations/$organizationId': typeof AuthenticatedOrganizationsOrganizationIdRoute
  '/_authenticated/reports/opportunity': typeof AuthenticatedReportsOpportunityRoute
  '/_authenticated/w/$workspaceSlug': typeof AuthenticatedWWorkspaceSlugRouteWithChildren
  '/_auth/sso/': typeof AuthSsoIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/portfolios/': typeof AuthenticatedPortfoliosIndexRoute
  '/_authenticated/workspaces/': typeof AuthenticatedWorkspacesIndexRoute
  '/_authenticated/portfolios/$portfolioId/workspaces': typeof AuthenticatedPortfoliosPortfolioIdWorkspacesRoute
  '/_authenticated/reports/opportunity_/$brandId': typeof AuthenticatedReportsOpportunityBrandIdRoute
  '/_authenticated/reports/opportunity_/products': typeof AuthenticatedReportsOpportunityProductsRoute
  '/_authenticated/w/$workspaceSlug/org-user-management': typeof AuthenticatedWWorkspaceSlugOrgUserManagementRoute
  '/_authenticated/w/$workspaceSlug/': typeof AuthenticatedWWorkspaceSlugIndexRoute
  '/_authenticated/w/$workspaceSlug/explore/$categoryL1': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1Route
  '/_authenticated/w/$workspaceSlug/organizations/$organizationId': typeof AuthenticatedWWorkspaceSlugOrganizationsOrganizationIdRoute
  '/_authenticated/w/$workspaceSlug/settings/integrations': typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsRouteWithChildren
  '/_authenticated/w/$workspaceSlug/settings/tags': typeof AuthenticatedWWorkspaceSlugSettingsTagsRoute
  '/_authenticated/w/$workspaceSlug/explore/': typeof AuthenticatedWWorkspaceSlugExploreIndexRoute
  '/_authenticated/w/$workspaceSlug/library/': typeof AuthenticatedWWorkspaceSlugLibraryIndexRoute
  '/_authenticated/w/$workspaceSlug/organizations/': typeof AuthenticatedWWorkspaceSlugOrganizationsIndexRoute
  '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4Route
  '/_authenticated/w/$workspaceSlug/library/assets/$assetId': typeof AuthenticatedWWorkspaceSlugLibraryAssetsAssetIdRoute
  '/_authenticated/w/$workspaceSlug/library/benchmarks/$benchmarkId': typeof AuthenticatedWWorkspaceSlugLibraryBenchmarksBenchmarkIdRoute
  '/_authenticated/w/$workspaceSlug/library/collections/$collectionId': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdRoute
  '/_authenticated/w/$workspaceSlug/library/products/$pdpId': typeof AuthenticatedWWorkspaceSlugLibraryProductsPdpIdRoute
  '/_authenticated/w/$workspaceSlug/settings/integrations/avc': typeof AuthenticatedWWorkspaceSlugSettingsIntegrationsAvcRoute
  '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4_/$classification': typeof AuthenticatedWWorkspaceSlugExploreCategoryL1CategoryL4ClassificationRoute
  '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/compare': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdCompareRoute
  '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/trends': typeof AuthenticatedWWorkspaceSlugLibraryCollectionsCollectionIdTrendsRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sso'
    | '/no-access'
    | '/'
    | '/sso/$orgSlug'
    | '/sso/callback'
    | '/sso/error'
    | '/organizations/$organizationId'
    | '/reports/opportunity'
    | '/w/$workspaceSlug'
    | '/sso/'
    | '/organizations'
    | '/portfolios'
    | '/workspaces'
    | '/portfolios/$portfolioId/workspaces'
    | '/reports/opportunity/$brandId'
    | '/reports/opportunity/products'
    | '/w/$workspaceSlug/org-user-management'
    | '/w/$workspaceSlug/'
    | '/w/$workspaceSlug/explore/$categoryL1'
    | '/w/$workspaceSlug/organizations/$organizationId'
    | '/w/$workspaceSlug/settings/integrations'
    | '/w/$workspaceSlug/settings/tags'
    | '/w/$workspaceSlug/explore'
    | '/w/$workspaceSlug/library'
    | '/w/$workspaceSlug/organizations'
    | '/w/$workspaceSlug/explore/$categoryL1/$categoryL4'
    | '/w/$workspaceSlug/library/assets/$assetId'
    | '/w/$workspaceSlug/library/benchmarks/$benchmarkId'
    | '/w/$workspaceSlug/library/collections/$collectionId'
    | '/w/$workspaceSlug/library/products/$pdpId'
    | '/w/$workspaceSlug/settings/integrations/avc'
    | '/w/$workspaceSlug/explore/$categoryL1/$categoryL4/$classification'
    | '/w/$workspaceSlug/library/collections/$collectionId/compare'
    | '/w/$workspaceSlug/library/collections/$collectionId/trends'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/no-access'
    | '/'
    | '/sso/$orgSlug'
    | '/sso/callback'
    | '/sso/error'
    | '/organizations/$organizationId'
    | '/reports/opportunity'
    | '/sso'
    | '/organizations'
    | '/portfolios'
    | '/workspaces'
    | '/portfolios/$portfolioId/workspaces'
    | '/reports/opportunity/$brandId'
    | '/reports/opportunity/products'
    | '/w/$workspaceSlug/org-user-management'
    | '/w/$workspaceSlug'
    | '/w/$workspaceSlug/explore/$categoryL1'
    | '/w/$workspaceSlug/organizations/$organizationId'
    | '/w/$workspaceSlug/settings/integrations'
    | '/w/$workspaceSlug/settings/tags'
    | '/w/$workspaceSlug/explore'
    | '/w/$workspaceSlug/library'
    | '/w/$workspaceSlug/organizations'
    | '/w/$workspaceSlug/explore/$categoryL1/$categoryL4'
    | '/w/$workspaceSlug/library/assets/$assetId'
    | '/w/$workspaceSlug/library/benchmarks/$benchmarkId'
    | '/w/$workspaceSlug/library/collections/$collectionId'
    | '/w/$workspaceSlug/library/products/$pdpId'
    | '/w/$workspaceSlug/settings/integrations/avc'
    | '/w/$workspaceSlug/explore/$categoryL1/$categoryL4/$classification'
    | '/w/$workspaceSlug/library/collections/$collectionId/compare'
    | '/w/$workspaceSlug/library/collections/$collectionId/trends'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/sso'
    | '/_authenticated/no-access'
    | '/_authenticated/'
    | '/_auth/sso/$orgSlug'
    | '/_auth/sso/callback'
    | '/_auth/sso/error'
    | '/_authenticated/organizations/$organizationId'
    | '/_authenticated/reports/opportunity'
    | '/_authenticated/w/$workspaceSlug'
    | '/_auth/sso/'
    | '/_authenticated/organizations/'
    | '/_authenticated/portfolios/'
    | '/_authenticated/workspaces/'
    | '/_authenticated/portfolios/$portfolioId/workspaces'
    | '/_authenticated/reports/opportunity_/$brandId'
    | '/_authenticated/reports/opportunity_/products'
    | '/_authenticated/w/$workspaceSlug/org-user-management'
    | '/_authenticated/w/$workspaceSlug/'
    | '/_authenticated/w/$workspaceSlug/explore/$categoryL1'
    | '/_authenticated/w/$workspaceSlug/organizations/$organizationId'
    | '/_authenticated/w/$workspaceSlug/settings/integrations'
    | '/_authenticated/w/$workspaceSlug/settings/tags'
    | '/_authenticated/w/$workspaceSlug/explore/'
    | '/_authenticated/w/$workspaceSlug/library/'
    | '/_authenticated/w/$workspaceSlug/organizations/'
    | '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4'
    | '/_authenticated/w/$workspaceSlug/library/assets/$assetId'
    | '/_authenticated/w/$workspaceSlug/library/benchmarks/$benchmarkId'
    | '/_authenticated/w/$workspaceSlug/library/collections/$collectionId'
    | '/_authenticated/w/$workspaceSlug/library/products/$pdpId'
    | '/_authenticated/w/$workspaceSlug/settings/integrations/avc'
    | '/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4_/$classification'
    | '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/compare'
    | '/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/trends'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSsoRoute: typeof AuthSsoRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSsoRoute: AuthSsoRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/_auth/forgot-password",
        "/_auth/login",
        "/_auth/reset-password",
        "/_auth/sso"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/no-access",
        "/_authenticated/",
        "/_authenticated/organizations/$organizationId",
        "/_authenticated/reports/opportunity",
        "/_authenticated/w/$workspaceSlug",
        "/_authenticated/organizations/",
        "/_authenticated/portfolios/",
        "/_authenticated/workspaces/",
        "/_authenticated/portfolios/$portfolioId/workspaces",
        "/_authenticated/reports/opportunity_/$brandId",
        "/_authenticated/reports/opportunity_/products"
      ]
    },
    "/_auth/forgot-password": {
      "filePath": "_auth/forgot-password.tsx"
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx"
    },
    "/_auth/reset-password": {
      "filePath": "_auth/reset-password.tsx"
    },
    "/_auth/sso": {
      "filePath": "_auth/sso.tsx",
      "children": [
        "/_auth/sso/$orgSlug",
        "/_auth/sso/callback",
        "/_auth/sso/error",
        "/_auth/sso/"
      ]
    },
    "/_authenticated/no-access": {
      "filePath": "_authenticated/no-access.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_auth/sso/$orgSlug": {
      "filePath": "_auth/sso.$orgSlug.tsx",
      "parent": "/_auth/sso"
    },
    "/_auth/sso/callback": {
      "filePath": "_auth/sso.callback.tsx",
      "parent": "/_auth/sso"
    },
    "/_auth/sso/error": {
      "filePath": "_auth/sso.error.tsx",
      "parent": "/_auth/sso"
    },
    "/_authenticated/organizations/$organizationId": {
      "filePath": "_authenticated/organizations/$organizationId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/reports/opportunity": {
      "filePath": "_authenticated/reports.opportunity.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/w/$workspaceSlug": {
      "filePath": "_authenticated/w/$workspaceSlug.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/w/$workspaceSlug/org-user-management",
        "/_authenticated/w/$workspaceSlug/",
        "/_authenticated/w/$workspaceSlug/explore/$categoryL1",
        "/_authenticated/w/$workspaceSlug/organizations/$organizationId",
        "/_authenticated/w/$workspaceSlug/settings/integrations",
        "/_authenticated/w/$workspaceSlug/settings/tags",
        "/_authenticated/w/$workspaceSlug/explore/",
        "/_authenticated/w/$workspaceSlug/library/",
        "/_authenticated/w/$workspaceSlug/organizations/",
        "/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4",
        "/_authenticated/w/$workspaceSlug/library/assets/$assetId",
        "/_authenticated/w/$workspaceSlug/library/benchmarks/$benchmarkId",
        "/_authenticated/w/$workspaceSlug/library/collections/$collectionId",
        "/_authenticated/w/$workspaceSlug/library/products/$pdpId",
        "/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4_/$classification",
        "/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/compare",
        "/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/trends"
      ]
    },
    "/_auth/sso/": {
      "filePath": "_auth/sso.index.tsx",
      "parent": "/_auth/sso"
    },
    "/_authenticated/organizations/": {
      "filePath": "_authenticated/organizations/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/portfolios/": {
      "filePath": "_authenticated/portfolios/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/workspaces/": {
      "filePath": "_authenticated/workspaces/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/portfolios/$portfolioId/workspaces": {
      "filePath": "_authenticated/portfolios/$portfolioId/workspaces.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/reports/opportunity_/$brandId": {
      "filePath": "_authenticated/reports.opportunity_.$brandId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/reports/opportunity_/products": {
      "filePath": "_authenticated/reports.opportunity_.products.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/w/$workspaceSlug/org-user-management": {
      "filePath": "_authenticated/w/$workspaceSlug/org-user-management.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/": {
      "filePath": "_authenticated/w/$workspaceSlug/index.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/explore/$categoryL1": {
      "filePath": "_authenticated/w/$workspaceSlug/explore/$categoryL1.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/organizations/$organizationId": {
      "filePath": "_authenticated/w/$workspaceSlug/organizations/$organizationId.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/settings/integrations": {
      "filePath": "_authenticated/w/$workspaceSlug/settings.integrations.tsx",
      "parent": "/_authenticated/w/$workspaceSlug",
      "children": [
        "/_authenticated/w/$workspaceSlug/settings/integrations/avc"
      ]
    },
    "/_authenticated/w/$workspaceSlug/settings/tags": {
      "filePath": "_authenticated/w/$workspaceSlug/settings.tags.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/explore/": {
      "filePath": "_authenticated/w/$workspaceSlug/explore/index.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/library/": {
      "filePath": "_authenticated/w/$workspaceSlug/library/index.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/organizations/": {
      "filePath": "_authenticated/w/$workspaceSlug/organizations/index.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4": {
      "filePath": "_authenticated/w/$workspaceSlug/explore/$categoryL1_.$categoryL4.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/library/assets/$assetId": {
      "filePath": "_authenticated/w/$workspaceSlug/library/assets.$assetId.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/library/benchmarks/$benchmarkId": {
      "filePath": "_authenticated/w/$workspaceSlug/library/benchmarks.$benchmarkId.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/library/collections/$collectionId": {
      "filePath": "_authenticated/w/$workspaceSlug/library/collections.$collectionId.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/library/products/$pdpId": {
      "filePath": "_authenticated/w/$workspaceSlug/library/products.$pdpId.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/settings/integrations/avc": {
      "filePath": "_authenticated/w/$workspaceSlug/settings.integrations.avc.tsx",
      "parent": "/_authenticated/w/$workspaceSlug/settings/integrations"
    },
    "/_authenticated/w/$workspaceSlug/explore/$categoryL1_/$categoryL4_/$classification": {
      "filePath": "_authenticated/w/$workspaceSlug/explore/$categoryL1_.$categoryL4_.$classification.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/compare": {
      "filePath": "_authenticated/w/$workspaceSlug/library/collections.$collectionId_.compare.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    },
    "/_authenticated/w/$workspaceSlug/library/collections/$collectionId_/trends": {
      "filePath": "_authenticated/w/$workspaceSlug/library/collections.$collectionId_.trends.tsx",
      "parent": "/_authenticated/w/$workspaceSlug"
    }
  }
}
ROUTE_MANIFEST_END */
